module.exports = __webpack_public_path__ + "assets/done-btn-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/done-btn-icon.svg
// module id = 816
// module chunks = 0